import React from 'react';
import MegaMenuVariant from './MegaMenuVariant';
import MegaMenuControl from './MegaMenuControl';

const MegaMenu = props => {
  const { isVariant } = props;

  return isVariant ? (
    <MegaMenuVariant {...props} />
  ) : (
    <MegaMenuControl {...props} />
  );
};

export default MegaMenu;
